<template>
  <div>
    <v-autocomplete
      v-model="selected"
      :items="get_data.customers"
      :label="label"
      :filter="filter"
      :no-data-text="lang.customers.datatable.no_results"
      item-text="name"
      item-value="id"
      :return-object="returnObject"
      filled
      chips
      multiple
      :clearable="clearable"
      clear-icon="mdi-broom"
      :class="{ 'hide-chips': hideChips }"
      autocomplete="off"
      hide-details
    >
      <template v-slot:selection="data">
        <v-chip
          v-if="!hideChips"
          :input-value="data.selected"
          close
          class="chip--select-multi"
          @click:close="remove(data.item)"
        >
          {{ `#${data.item.id} ${data.item.name}` }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content>
            <v-list-item-title v-text="data.item"></v-list-item-title>
          </v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-content>
            <v-list-item-title>
              <v-row class="px-0 mx-0">
                <v-col cols="12">{{ `#${data.item.id}  ${data.item.name}` }}</v-col>
              </v-row>
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-row class="px-0 mx-0">
                <v-col cols="6">
                  <v-icon
                    small
                    color="blue"
                  >
                    mdi-phone
                  </v-icon>
                  {{ data.item.phone | phoneMask }}
                </v-col>
                <v-col cols="6">
                  <v-icon
                    small
                    color="green"
                  >
                    mdi-card-bulleted
                  </v-icon>
                  {{ data.item.identity | cpfMask }}
                </v-col>
              </v-row>
            </v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  mixins: [ appdata, utils ],
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    label: {
      type: String,
      default: () => {
        return this.lang.historic.filters.customers.title
      }
    },
    hideChips: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      selected: (this.value ? [ ...this.value ] : [])
    }
  },
  watch: {
    selected: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.value) !== JSON.stringify(newVal)) this.$emit('input', [ ...this.selected ])
      }
    },
    value: {
      deep: true,
      handler (newVal) {
        if (JSON.stringify(this.selected) !== JSON.stringify(newVal)) this.selected = [ ...this.value ]
      }
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    filter (item, queryText, itemText) {
      console.log('item', item)
      console.log('queryText', queryText)
      return (
        (queryText && item.name.toLowerCase().trim().search(queryText) > -1) ||
        (queryText && item.id === parseInt(queryText)) ||
        (queryText && String(item.phone).toLowerCase().trim().search(String(queryText)) > -1) ||
        (queryText && String(item.identity).toLowerCase().trim().search(String(queryText)) > -1)
      )
    },
    remove (item) {
      const obj = (this.returnObject ? this.selected.find(el => el.id === item.id) : this.selected.find(el => el === item.id))
      const index = this.selected.indexOf(obj)
      if (index >= 0) this.selected.splice(index, 1)
    }
  }
}
</script>

<style scoped src="../styles/autocomplete.scss" lang="scss"></style>
